<template>
    <td style="min-width: 156px; padding: 0px;"
        align="center"
        @click="openEdit">
        <template v-if="editMode">
            <EditTableCell
                style="width: 156px"
                :value="`${value}`"
                @input="onValueChanged"
                @close="closeEdit()"
                :rules="rules"
                :suffix="suffix"
                :loading="loading">
            </EditTableCell>
        </template>
        <template v-else>
            <slot :value="value" :suffix="suffix" :locked="locked">
                <span v-if="value">{{ value }}{{suffix}}</span>
                <span v-else>N/A</span>
                <v-icon v-if="locked">lock_outline</v-icon>
            </slot>
        </template>
    </td>
</template>

<script>
import EditTableCell from "@/components/forecasting/EditTableCell.vue";

export default {
    components: {
        EditTableCell
    },
    props: {
        value: {
            type: String,
            required: true
        },
        rules: {
            type: Array,
            required: false,
            default() {
                return []
            }
        },
        suffix: {
            type: String,
            required: false,
            default: null
        },
        locked: {
            type: Boolean,
            required: false,
            default: false
        },
        editable: {
            type: Boolean,
            required: true
        }
    },
    data(){
        return {
            editMode: false,
            localValue: null,
            loading: false
        };
    },
    watch: {
        value(){
            // Resolve the submit
            if(this.editMode){
                this.loading = false;
                this.closeEdit();
            }
        }
    },
    computed: {
    },
    methods: {
        openEdit(){
            if(!this.editable){
                return;
            }

            if(this.locked){
                return;
            }

            this.editMode = true;
        },
        closeEdit(){
            this.editMode = false;
        },
        onValueChanged(event){
            var value = event.value;
            this.loading = true;
            this.$emit("input", value);
        }
    },
    created(){
        
    }
}
</script>